import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWallet, faMagnifyingGlass, faBolt } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import ItemCard1 from "../components/ItemCard1";
import Select from "react-select";
import { useUser } from "../utils/UserContext";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import Pie from "../components/chart/Pie";
import BalanceCard4 from "../components/BalanceCard4";

function Assets() {
  const { user } = useUser();
  const [notifications, setNotifications] = useState([])
  const [assethistory, setAssethistory] = useState([]);
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [wallet, setWallet] = useState([]);
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchNotification1: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setNotifications(data.notifications);
      }
    })
    .catch(err => {
        console.error(err)
    })
  }, []);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWallet(data.wallet);
      }
    })
    .catch(err => {
      
    })
  }, [user]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const walletMap = wallet.reduce((acc, item) => {
      const key = item.coinName?.trim().toLowerCase();
      acc[key] = parseFloat(item.balance) || 0;
      return acc;
    }, {});
    let total = 0;
    let cryptoTotal = 0;
    let fiatTotal = 0;
    let stockTotal = 0;
    const applyWalletBalance = (list, categoryTotal) => {
      let categorySum = 0;
      const result = list.map(item => {
        const key = item.name?.trim().toLowerCase();
        const matchedBalance = walletMap[key];
        const amount = matchedBalance || 0;
        const value = amount * item.price;
        categorySum += value;
        return {
          ...item,
          amount: matchedBalance || 0
        };
      });
      return { result, categorySum };
    };

    const { result: cryptoWithBalance, categorySum: cryptoSum } = applyWalletBalance(crypto);
    const { result: fiatWithBalance, categorySum: fiatSum } = applyWalletBalance(fiat);
    const { result: stockWithBalance, categorySum: stockSum } = applyWalletBalance(stock);
    cryptoTotal = cryptoSum;
    fiatTotal = fiatSum;
    stockTotal = stockSum;
    total = cryptoTotal + fiatTotal + stockTotal;
    const merged = [
      ...cryptoWithBalance,
      ...fiatWithBalance,
      ...stockWithBalance
    ];
    const sorted = merged.sort((a, b) => {
      if (b.amount > 0 && a.amount === 0) return 1;
      if (a.amount > 0 && b.amount === 0) return -1;
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);
    setAssetBal(total);
    setCryptoBal(cryptoTotal);
    setFiatBal(fiatTotal);
    setStockBal(stockTotal);
  }, [crypto, fiat, stock, wallet]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [see, setSee] = useState(true);
  const [assetBal, setAssetBal] = useState(0);
  const [cryptoBal, setCryptoBal] = useState(0);
  const [fiatBal, setFiatBal] = useState(0);
  const [stockBal, setStockBal] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const filteroptions = [
    { value: "all", label: "All Assets" },
    { value: "crypto", label: "Crypto Assets" },
    { value: "fiat", label: "Fiat Assets" },
    { value: "stocks", label: "Stocks Assets" },
  ];
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const filteredAssets = assethistory.filter(filteredAsset => 
    Object.values(filteredAsset).some(value => 
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    ) &&
    (selectedFilter === 'all' || filteredAsset.type.toLowerCase() === selectedFilter.toLowerCase())
  )
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Assets" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Assets" icon={<FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-xxl-4 col-lg-6 col-12">
                <div className="mycard mt-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="text-secondary fw-bold mb-0">Total Asset Balance: <FontAwesomeIcon icon={(see === true)?faEye:faEyeSlash} className="ms-2" style={{fontSize: '16px'}} onClick={() => {
                      setSee(see === true ? false : true);
                    }}/></p>
                  </div>
                  <h2 className="fs-4 fw-bold mb-3">{see ? `${getCurrencySymbol(user?.currency)}${formatCurrency(assetBal * rate)}` : '******'}</h2>
                  <Pie crypto={cryptoBal * rate} fiat={fiatBal * rate} stock={stockBal * rate}/>
                </div>
              </div>
              <div className="col-xxl-4 col-lg-6 col-12">
                <div className="mycard mt-2">
                  <p className="text-secondary fw-bold mb-0">Portfolio Overview</p>
                  <hr className="my-2"/>
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 text-white fw-semibold" style={{fontSize:'14px'}}>Cryptocurrencies</p>
                    <p className="mb-0 text-white fw-semibold" style={{fontSize:'12px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(cryptoBal * rate)} {user?.currency}</p>
                  </div>
                  <div className="progress" style={{ height: "12px", backgroundColor: 'rgba(66, 84, 251, 0.2)'}}>
                    <div className="progress-bar" style={{ width: `${(parseFloat(cryptoBal * rate)/(parseFloat(cryptoBal * rate)+parseFloat(fiatBal * rate)+parseFloat(stockBal * rate))) * 100}%`, backgroundColor: 'rgb(66, 84, 251)' }}></div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-2">
                    <p className="mb-0 text-white fw-semibold" style={{fontSize:'14px'}}>Fiats</p>
                    <p className="mb-0 text-white fw-semibold" style={{fontSize:'12px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(fiatBal * rate)} {user?.currency}</p>
                  </div>
                  <div className="progress" style={{ height: "12px", backgroundColor: 'rgba(255, 180, 34, 0.2)'}}>
                    <div className="progress-bar" style={{ width: `${(parseFloat(fiatBal * rate)/(parseFloat(cryptoBal * rate)+parseFloat(fiatBal * rate)+parseFloat(stockBal * rate))) * 100}%`, backgroundColor: 'rgb(255, 180, 34)' }}></div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-2">
                    <p className="mb-0 text-white fw-semibold" style={{fontSize:'14px'}}>Stocks</p>
                    <p className="mb-0 text-white fw-semibold" style={{fontSize:'12px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(stockBal * rate)} {user?.currency}</p>
                  </div>
                  <div className="progress" style={{ height: "12px", backgroundColor: 'rgba(250, 79, 88, 0.2)'}}>
                    <div className="progress-bar" style={{ width: `${(parseFloat(stockBal * rate)/(parseFloat(cryptoBal * rate)+parseFloat(fiatBal * rate)+parseFloat(stockBal * rate))) * 100}%`, backgroundColor: 'rgb(250, 79, 88)' }}></div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-4 col-12">
                <div className="mycard mt-2">
                  <h6 className="text-secondary fw-bold mb-2">Recent Activity</h6>
                  {notifications.length > 0 && (
                    notifications.map((notification) => (
                      <ItemCard1 key={notification.id} text={notification.subject} date={notification.date}/>
                    ))
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="mycard mt-2" style={{minHeight: '44vh'}}>
                    <div className="d-lg-flex align-items-center justify-content-between">
                        <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>All your assets</h6>
                        <div className="d-flex align-items-center mt-2 mt-lg-0">
                            <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                <input 
                                type="text" 
                                placeholder="Search for assets" 
                                className="searchinput"
                                value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <Select 
                                options={filteroptions}
                                value={filteroptions.find((opt) => opt.value === selectedFilter)}
                                onChange={(e) => setSelectedFilter(e.value)}
                                styles={darkThemeStyles}
                                className="w-full"
                            />
                        </div>
                    </div>
                    <div className="row">
                      {filteredAssets.length > 0 ? (
                          filteredAssets.map((asset) => (
                            <div className="col-lg-4 col-12 g-4">
                              <BalanceCard4 name={asset.name} icon={<img src={asset.logo} alt={asset.name} style={{width:'80%'}} />} symbol={asset.symbol} type={asset.type} currency={getCurrencySymbol(user?.currency)} price={formatCurrency(asset.price * rate)} amount={asset.amount} amountUSD={formatCurrency(((asset.amount * asset.price) * rate))}/>
                            </div>
                          ))
                      ) : (
                        <p className="mt-5 pt-5 text-center">You have not gotten an asset yet.</p>
                      )}
                    </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Assets